import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Carousel } from "../Carousel";
import {
  CarouselTile,
  TileImageContainer,
  TileImage,
  TileContent,
} from "../CarouselTile";
import { Section, SectionTitle, SectionDescription } from "../Section";
import styles from "./CompleteYourTripSection.module.scss";
import { useCompleteYourTripBanners } from "./hooks";
import { completeYourTripBanners } from "@/utils/banners";
import { getBannerImageUrl } from "@/utils/banners/images";

export const CompleteYourTripSection = () => {
  const { t } = useI18nContext();
  const [, cn] = useModuleBEM(styles, "CompleteYourTripSection");

  // Skip the first item as it's the section header data
  const banners = useCompleteYourTripBanners();

  return (
    <Section>
      <div>
        <SectionTitle as="h2">{t("home.completeYourTrip.title")}</SectionTitle>
        <SectionDescription>
          {t("home.completeYourTrip.description")}
        </SectionDescription>
        <div className={cn("carousel-container")}>
          <Carousel
            items={banners.map((banner) => {
              const imagePath = getBannerImageUrl(banner.imageFile);

              return (
                <a
                  key={banner.name}
                  href={banner.linkTarget}
                  target="_blank"
                  rel="noopener"
                  referrerpolicy="no-referrer-when-downgrade"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <CarouselTile>
                    <TileImageContainer>
                      <TileImage src={imagePath} alt={banner.headerCopy} />
                    </TileImageContainer>
                    <TileContent>
                      <h3 className={cn("title")} data-carousel-title>
                        {banner.headerCopy}
                      </h3>
                      <p className={cn("description")}>
                        {banner.subheaderCopy}
                      </p>
                    </TileContent>
                  </CarouselTile>
                </a>
              );
            })}
          />
        </div>
      </div>
    </Section>
  );
};
